import type { Component } from 'svelte';
import type { HTMLAttributes } from 'svelte/elements';
import type { IconProps as LucideIconProps } from '@lucide/svelte';

export const sizes = {
	xs: 'size-3', // 12px
	sm: 'size-4', // 16px
	md: 'size-5', // 20px
	lg: 'size-6', // 24px
	xl: 'size-8', // 32px
	hero: 'size-12' // 48px
} as const;

export const variants = {
	default: 'text-foreground',
	subtle: 'text-muted-foreground',
	primary: 'text-primary',
	destructive: 'text-destructive',
	success: 'text-success',
	warning: 'text-warning',
	inherit: '' // No class - inherits color from parent (currentColor)
} as const;

export type IconSize = keyof typeof sizes;
export type IconVariant = keyof typeof variants;

export interface IconProps extends HTMLAttributes<SVGElement> {
	icon: any;
	size?: IconSize;
	variant?: IconVariant;
	class?: string;
	strokeWidth?: number;
}
